export default __webpack_public_path__ + "static/media/presentation_for_parents.0e587954.pdf";